import { GrainOverlay } from "@/components/ui/grain-overlay";
import { cn } from "@/lib/utils";

import { NavPreviewTealGradientBackground } from "./nav-preview-teal-gradient";

export function NavPreviewShell({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "rounded-ds-m border-grey-100 bg-grey-0 relative h-[272px] w-[400px] shrink-0 overflow-hidden border",
        className
      )}
    >
      {children}
    </div>
  );
}

export function NavFloatingCard({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "border-grey-100 bg-grey-0 rounded-tl-ds-xl absolute top-[39px] left-[39px] z-[1] h-[232px] w-[360px] overflow-visible border",
        "shadow-[-11px_9px_32px_rgba(0,0,0,0.05)]",
        className
      )}
    >
      {children}
    </div>
  );
}

type NavPreviewGradientVariant = "purple" | "teal";

export function NavPreviewGradientBackground({
  variant,
}: {
  variant: NavPreviewGradientVariant;
}) {
  const isPurple = variant === "purple";

  if (!isPurple) {
    return <NavPreviewTealGradientBackground />;
  }

  return (
    <>
      <div
        aria-hidden
        className={cn(
          "pointer-events-none absolute -inset-40 z-0",
          "bg-[#feebfd]"
        )}
      />
      <div
        aria-hidden
        className={cn(
          "pointer-events-none absolute -inset-32 z-0 opacity-90",
          "bg-[radial-gradient(circle_at_20%_15%,#f5d4ff_0%,transparent_45%),radial-gradient(circle_at_85%_25%,#ffc4e8_0%,transparent_50%),radial-gradient(circle_at_50%_90%,#e4edff_0%,transparent_55%)]"
        )}
      />
      <GrainOverlay
        baseFrequency={0.85}
        numOctaves={2}
        contrast={2}
        opacity={0.45}
        blendMode="soft-light"
      />
      <div
        aria-hidden
        className="from-grey-0/0 via-grey-0/30 to-grey-0 pointer-events-none absolute inset-x-0 bottom-0 z-[1] h-28 bg-gradient-to-b"
      />
    </>
  );
}
